import React, { FC, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Form from '@sezenta/antd-schema-form';
import { Button, Input, Modal } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useConnection } from '@sezenta/connection';

export const ChangePassword: FC = () => {
  const { t } = useTranslation();
  const connection = useConnection();
  const navigate = useNavigate();
  const { email, token } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // const schema = useMemo(() => {
  //   return [
  //     {
  //       id: 'password',
  //       name: `${t('changePw.password')}`,
  //       type: 'password',
  //       props: {
  //         placeholder: `${t('changePw.placeholder.password')}`,
  //       },
  //       options: {
  //         rules: [
  //           {
  //             required: true,
  //             message: `${t('changePw.required.password')}`,
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       id: 'reEnterPassword',
  //       name: `${t('changePw.confirmPw')}`,
  //       type: 'password',
  //       props: {
  //         placeholder: `${t('changePw.placeholder.confirmPw')}`,
  //       },
  //       options: {
  //         rules: [
  //           {
  //             required: true,
  //             message: `${t('changePw.required.confirmPw')}`,
  //           },
  //         ],
  //       },
  //     },
  //   ];
  // }, [t]);

  const onSubmit = useCallback(
    (data: any) => {
      const temp = { ...data };
      delete temp.reEnterPassword;
      temp.email = email;
      temp.token = token;

      setLoading(true);

      connection
        .post('auth/set-password', temp)
        .then((v) => {
          Modal.success({
            title: 'Success',
            content: 'Password changed successfully. ',
            onOk: () => navigate('/webux/users'),
          });
        })
        .catch((e) => {
          console.log('EEEEEEEEEEEE', e.response);
          Modal.error({ title: 'Error', content: e.response.data.message });
        })
        .finally(() => {
          setLoading(false);
          form.resetFields();
        });
    },
    [connection, email, form, navigate, token],
  );

  return (
    <div
      className="login-form grid place-items-center h-screen w-screen bg-top"
      style={{ backgroundImage: "url('/img/zig-zag.png')" }}
    >
      <div
        className="bg-white rounded-[45px] w-[770px] h-[560px] flex p-4"
        style={{ boxShadow: '0px 6px 28px 2px rgba(0, 0, 0, 0.12)' }}
      >
        <div className="flex flex-col w-[60%] h-full items-center py-6 px-6 pl-3">
          <h1 className="text-3xl font-semibold mb-4">Change Password</h1>
          <p className="text-gray-500">
            Enter your password to change the password.
          </p>
          <Form
            form={form}
            name="login"
            className="flex flex-col w-full gap-2 mt-6"
            onFinish={onSubmit}
          >
            <div>
              <label>Password</label>
              <Form.Item
                name="pasword"
                rules={[
                  { required: true, message: 'Please Enter Your New Password' },
                ]}
              >
                <Input.Password placeholder="New Password" />
              </Form.Item>
            </div>
            <div>
              <label>Re-Enter Password</label>
              <Form.Item
                name="confirmPassword"
                rules={[
                  { required: true, message: 'Please Re-Enter Your Password' },
                ]}
              >
                <Input.Password placeholder="Re-Enter Password" />
              </Form.Item>
            </div>
            <div className="flex flex-col mt-0">
              <Form.Item>
                <Button
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  className="w-full mt-1"
                  style={{
                    height: '50px',
                    borderRadius: '12px',
                    fontSize: '20px',
                  }}
                >
                  Change Password
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
        <div
          className="w-[50%] h-full rounded-r-[35px] overflow-hidden animate-bg-motion"
          style={{
            backgroundImage: "url('/img/login-side.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
      </div>
    </div>

    // <AuthLayout title={t('changePw.title')}>
    //   <Form form={form} layout="vertical" onFinish={onSubmit}>
    //     <Form.Items schema={schema} />
    //     <Button
    //       className="w-full"
    //       loading={loading}
    //       type="primary"
    //       htmlType="submit"
    //     >
    //       {t('changePw.changePw')}
    //     </Button>
    //   </Form>
    // </AuthLayout>
  );
};
